<template>
    <header class="header" ref="headerRef">
        <div class="header__wrapper">
            <img class="kasanowa-hover" src="~@/assets/images/logo.png" alt="kasanowa" @click="navigateTo(!isAdminWholesaler ? '/dashboard' : `/warehouse/details/${userInfo.wholesaler_ids[0]}`)" />
            <div id="mobile-menu" class="kasanowa-mobile kasanowa-hover header__hamburger" @click="toggleMobileMenu">
                <KIcon v-if="!isMobileMenuActive" icon="hamburger" width="24" height="24" />
                <KIcon v-if="isMobileMenuActive" icon="close" width="24" height="24" />
            </div>
            <div class="kasanowa-desktop header__buttons-wrapper">
                <HeaderButtons :is-mobile-menu="false" />
            </div>
        </div>
        <v-slide-y-transition>
            <HeaderButtons v-show="isMobileMenuActive" is-mobile-menu />
        </v-slide-y-transition>
    </header>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from '@vue/runtime-core';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/user';
import { navigateTo } from '@/hooks/NavigateHooks';
import KIcon from '@/components/atoms/KIcon.vue';
import HeaderButtons from '@/views/Layout/components/HeaderButtons.vue';

const { isAdminWholesaler, userInfo } = storeToRefs(useUserStore());

const isMobileMenuActive = ref<boolean>(false);
const toggleMobileMenu = () => {
    isMobileMenuActive.value = !isMobileMenuActive.value;
};

const headerRef = ref<HTMLElement | null>(null);
const handleClickOutside = (event: Event) => {
    const target = event.target as HTMLElement;

    if (headerRef.value && !headerRef.value.contains(target)) {
        if (isMobileMenuActive.value) {
            isMobileMenuActive.value = false;
        }
    }
};
onMounted(() => {
    document.addEventListener('click', handleClickOutside);
});
onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
});
</script>

<style scoped lang="scss">
.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: rgba($black, 0.5);
    backdrop-filter: blur(5px) saturate(150%);
    -webkit-backdrop-filter: blur(5px) saturate(150%);
    padding: 8px 24px;
    z-index: 10;
    border-bottom: 1px solid rgba($black, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    fill: $white;
    flex-direction: column;

    @include media-breakpoint-up(lg) {
        flex-direction: row;
        padding: 0 24px;
    }

    svg {
        fill: $white;
        pointer-events: none;  // Ikona nie przechwytuje kliknięć
    }

    img {
        width: 65px;
        height: 53px;

        @include media-breakpoint-up(lg) {
            position: absolute;
            top: 0;
            width: 220px;
            height: 185px;
        }
    }

    &__wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        max-width: calc(1920px - 300px - 300px);

        @include media-breakpoint-up(lg) {
            justify-content: flex-start;
        }
    }

    &__hamburger {
        padding: 10px 0 10px 10px;
    }

    &__buttons-wrapper {
        width: 100%;
    }
}
</style>
